import toast from "react-hot-toast";
import { color } from "src/styles/globals";
import { Body } from "sunday-component";

/**
 * Renders a toast notification with the copied message.
 * @example
 * ```tsx
 * const onWriteClipboard = () => {
 *  navigator.clipboard.writeText(orderId);
 *  Toast(text:string); // <<-- renders the toast
 * };
 *
 * ```
 *
 * @return {JSX.Element} The rendered toast notification.
 */
const Toast = (text: string) => {
  return toast(
    <Body level={7} style={{ color: color.white }}>
      {text}
    </Body>,
    {
      position: "bottom-center",
      style: {
        borderRadius: "12px",
        backgroundColor: color.charcoal10,
        padding: "12px",
      },
      duration: 2000,
    }
  );
};

export default Toast;
